import React from 'react'

const Autoplay3 = ({ color = '#323232' }) => {
  return (
    <svg
      version={1.0}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      className="cursor-pointer w-full h-full"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2955 4609 c-31 -17 -505 -491 -521 -521 -18 -35 -18 -102 1 -142 9
  -18 125 -141 258 -273 216 -214 247 -241 287 -251 63 -15 115 -1 158 42 30 29
  36 43 40 89 6 71 -7 92 -117 202 -50 49 -91 94 -91 99 0 14 351 -1 455 -19
  514 -91 921 -492 1032 -1015 24 -117 24 -372 -1 -488 -101 -469 -429 -835
  -875 -976 -105 -33 -235 -56 -320 -56 -118 0 -178 -28 -207 -97 -31 -73 -7
  -158 56 -201 34 -23 39 -24 180 -18 568 22 1097 375 1351 901 271 563 190
  1223 -212 1710 -225 274 -544 469 -890 544 -110 24 -306 41 -462 41 l-111 0
  101 103 c107 108 119 130 111 202 -6 53 -37 97 -82 119 -39 18 -111 21 -141 5z"
        />
        <path
          d="M1725 4133 c-81 -10 -237 -48 -328 -79 -783 -273 -1231 -1104 -1027
  -1904 148 -580 627 -1042 1211 -1169 110 -24 306 -41 463 -41 l111 0 -97 -97
  c-53 -54 -101 -108 -107 -120 -29 -57 -3 -156 51 -195 33 -23 101 -34 145 -24
  31 8 514 481 539 528 18 35 18 102 -1 142 -9 18 -125 141 -258 273 -216 214
  -247 241 -287 251 -63 15 -115 1 -158 -42 -30 -29 -36 -43 -40 -89 -6 -71 7
  -92 117 -202 50 -49 91 -94 91 -99 0 -14 -351 1 -455 19 -514 91 -920 491
  -1032 1015 -22 103 -24 359 -5 464 29 154 103 340 187 471 211 330 598 562
  970 581 134 7 187 20 218 52 71 74 60 195 -22 249 -31 21 -45 23 -145 22 -61
  -1 -124 -4 -141 -6z"
        />
        <path
          d="M2824 3190 c-39 -16 -703 -519 -721 -547 -24 -37 -24 -129 0 -166 16
  -24 611 -479 690 -527 48 -29 132 -27 178 4 70 48 69 36 69 599 0 333 -4 515
  -11 534 -31 84 -130 133 -205 103z"
        />
      </g>
    </svg>
  )
}

export default Autoplay3
